<template>
  <div>
    <div class="card-header row">
      <!-- This Header is common for all pages -->
      <!-- noCheckBox - to show checkbox or not
          deselectAll - by default all checkboxes are selected
          hideSelectAll - all checkboxes are not selected
          checkboxSpace - there will be space in header for checkbox (when checkbox is not shown) Eg: Ready for billing
      -->
      <div class="card-header-col card-col wp3" v-if="!noCheckbox">
        <span v-if="deselectAll">
          <div class="checkselect">
            <Checkbox checked @change="clearAll()"></Checkbox>
          </div>
        </span>
        <span v-else-if="!hideSelectAll">
          <Checkbox @change="selectAll($event)"></Checkbox>
        </span>
      </div>
      <div class="card-header-col card-col wp3" v-else-if="checkboxSpace"/>
      <div class="card-header-col card-col"
        v-for="(title, index) in headers"
        :class="title.class"
        :key="index">
        <Tooltip class="item" effect="dark" placement="bottom" v-if="title.headerTooltip">
          <div slot="content" class="tooltipcontent">{{title.headerTooltip}}</div>
          <button>{{title.tlabel ? $t(title.tlabel) : title.head}}</button>
        </Tooltip>
        <span v-else>{{title.tlabel ? $t(title.tlabel) : title.head}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    deselectAll: {
      type: Boolean,
      default: false,
    },
    hideSelectAll: {
      type: Boolean,
      default: false,
    },
    noCheckbox: {
      type: Boolean,
      default: false,
    },
    checkboxSpace: {
      type: Boolean,
      default: false,
    },
    headers: {
      type: Array,
      default: () => [],
    },
    showSelectAllOption: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clearAll() {
      this.$emit('clearAll');
    },
    selectAll(value) {
      this.$emit('selectAll',value);
    },
  },
};
</script>
